import type { TRecord } from '@rehaje/shared'

const CamelCaseRE = /^(?:\s*\w*\.)?(\w)(\w*)/

const cache: TRecord = {}
export function camelCase(target: string) {
  if (cache[target]) return cache[target]
  cache[target] = target.replace(
    CamelCaseRE,
    (_, $1, $2) => $1?.toLowerCase() + $2
  )
  return cache[target]
}
